import React from 'react';
import { connect } from 'react-redux';
import { updateData, updateFilterData, updateEditData } from "../actions";
import ControlService from '../../helper/controlservice';
import DatePicker from "react-datepicker";
import * as dateFns from 'date-fns';

function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(updateData(key, value, storekey)),
        updateEdit: (key, value) => dispatch(updateEditData(key, value)),
        updateFilter: (key, value, key2) => dispatch(updateFilterData(key, value, key2))
    };
}
const mapStateToProps = state => ({
    data: state.formDataReducer,
    token: state.formLoginReducer.token,
    filterdata: state.formDataReducer.filterdata,
    editformdata: state.formDataReducer.editformdata,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading
});

class DateUI extends React.PureComponent {
    state = {
        from: '',
        to: '',
        touched: false,
        value: ''
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        var nextData = nextProps.data && nextProps.data[nextProps.formid] ? nextProps.data[nextProps.formid] : {};
        return {
            value: nextData[nextProps.control.key]
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.value && this.state.value != prevState.value) {
            ControlService().controlVaildationCheck(this.props);
        }
    }
    componentDidMount() {
        ControlService().controlVaildationCheck(this.props);
    }
    onValueChange(value, control, action) {
        debugger;
        const { formid } = this.props;
        var result = null;
        if (control.storeinutc) {
            if (value) {
                // value = new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate(), value.getHours() + 1, value.getMinutes(), value.getSeconds()))

                result = value.toJSON();// moment(value).format("YYYY-MM-DDThh:mm:ss") + 'Z';
            }
        } else {
            result = value ? dateFns.format(
                value,
                control.istimeenable ? 'MM/dd/yyyy h:mm a' : 'MM/dd/yyyy'
            ) : null;
        }
        this.props.update(control.key, result, formid)

        var validation = ControlService().validate(control, value);
        var formValidation = this.props.data[formid + "_validation"] ? this.props.data[formid + "_validation"] : {}
        if (validation && (!formValidation[control.key] || formValidation[control.key].status != "pass")) {
            this.props.update(control.key, { "status": "pass", "control": control, touched: false }, formid + "_validation")
        } else if (!validation && (!formValidation[control.key] || formValidation[control.key].status != "fail")) {
            this.props.update(control.key, { "status": "fail", "control": control, touched: false }, formid + "_validation")
        }

    }
    handleBlur = () => {
        this.setState({
            touched: true,
        }, () => ControlService().controlVaildationCheck(this.props));
    }
    MinDate(control, data) {
        // var minDate = null;
        // var date = null;
        if (control.startdatebindingtype == 'currentdate') {
            return new Date();
        } else if (control.startdatebindingtype == 'date') {
            return new Date(control.minDate);
        } else if (data[control.modelid] != "" && data[control.modelid] && control.startdatebindingtype == 'model') {
            return new Date(data[control.modelid]);
        }
    }
    MinTime = (_this, time) => {
        debugger;
        const { control, formid } = _this.props;
        var data = _this.props.data[formid] ? _this.props.data[formid] : {};

        var currentDate = new Date();
        var selectedDate = new Date(time);
        if (control.startdatebindingtype == 'currentdate') {
            currentDate = new Date();
        } else if (control.startdatebindingtype == 'date') {
            currentDate = new Date(control.minDate);
        } else if (data[control.modelid] != "" && data[control.modelid] && control.startdatebindingtype == 'model') {
            currentDate = new Date(data[control.modelid]);
        }
        return currentDate.getTime() < selectedDate.getTime();
    }
    shouldMarkError(control, data) {
        const validate = ControlService().validate(control, data[control.key]);

        const validation = this.props.data[this.props.formid + "_validation"] ? this.props.data[this.props.formid + "_validation"][control.key] : null;
        const isTouchedOutside = validation ? validation.touched : false;
        const shouldShow = this.state.touched || isTouchedOutside;
        return validate ? !validate : shouldShow;
    }
    render() {
        const { control, action, formid, token } = this.props;
        var data = this.props.data[formid] ? this.props.data[formid] : {};
        const shouldMarkError = this.shouldMarkError(control, data);
        return (
            <div className="form-group">
                {control.label &&
                    <label className="" htmlFor={control.key}>
                        {control.label}
                        {control.require ? <sup className="text-danger font-weight-bold" >*</sup> : null}
                        {control.showhelptext &&
                            <span className={"custom-tooltip"}>
                                <i className={"fa fa-question-circle ml-2 help-text"}></i>
                                <span className={"tooltip tooltip-" + control.helpdirection}>{control.help}</span>
                            </span>
                        }
                    </label>
                }
                {control.imageurl ? <img src={control.imageurl} width="100" height="100" alt={control.label} className="mb-2 img-fluid" /> : null}
                <div className="input-group datepicker-outer">
                    <div className="input-group-prepend">
                        <span className="input-group-text"><i className="fa fa-calendar"></i></span>
                    </div>
                    {control.istimeenable ?
                        <React.Fragment>
                            {control.portalInRoot ?
                                <DatePicker
                                    showYearDropdown={!control.hideYearDropdown}
                                    dropdownMode={control.dropdownMode ? "select" : ""}
                                    showMonthDropdown={control.showMonthDropdown}
                                    scrollableYearDropdown={control.scrollableYearDropdown}
                                    yearDropdownItemNumber={control.yearDropdownItemNumber ? control.yearDropdownItemNumber : 15}
                                    placeholderText={control.placeholder}
                                    className={'form-control ' + (shouldMarkError ? "border-danger" : "")}
                                    selected={data[control.key] ? new Date(ControlService().utcToZonedTime(data[control.key], control.dateformat, token)) : null}
                                    showTimeSelect
                                    onChange={(e) => this.onValueChange(e, control, action)}
                                    timeFormat="h:mm a"
                                    timeIntervals={15}
                                    isClearable={true}
                                    dateFormat="MM/dd/yyyy h:mm a"
                                    minDate={this.MinDate(control, data)}
                                    filterTime={this.MinTime.bind(control, this)}
                                    onBlur={() => { this.handleBlur(); }}
                                    popperPlacement="auto"
                                    disabled={this.props.disabled}
                                    portalId="root"
                                // maxDate={addDays(new Date(), 5)}
                                />
                                :
                                <DatePicker
                                    showYearDropdown={!control.hideYearDropdown}
                                    dropdownMode={control.dropdownMode ? "select" : ""}
                                    showMonthDropdown={control.showMonthDropdown}
                                    scrollableYearDropdown={control.scrollableYearDropdown}
                                    yearDropdownItemNumber={control.yearDropdownItemNumber ? control.yearDropdownItemNumber : 15}
                                    placeholderText={control.placeholder}
                                    className={'form-control ' + (shouldMarkError ? "border-danger" : "")}
                                    selected={data[control.key] ? new Date(ControlService().utcToZonedTime(data[control.key], control.dateformat, token)) : null}
                                    showTimeSelect
                                    onChange={(e) => this.onValueChange(e, control, action)}
                                    timeFormat="h:mm a"
                                    timeIntervals={15}
                                    isClearable={true}
                                    dateFormat="MM/dd/yyyy h:mm a"
                                    minDate={this.MinDate(control, data)}
                                    filterTime={this.MinTime.bind(control,this)}
                                    onBlur={() => { this.handleBlur(); }}
                                    popperPlacement={control.popupplacement == 'auto' ? (control.popupplacement + '-left') : (control.popupplacement + '-start')}
                                    disabled={this.props.disabled}
                                // maxDate={addDays(new Date(), 5)}
                                />
                            }
                        </React.Fragment>
                        :
                        <React.Fragment>
                            {control.portalInRoot ?
                                <DatePicker
                                    showYearDropdown={!control.hideYearDropdown}
                                    dropdownMode={control.dropdownMode ? "select" : "scroll"}
                                    showMonthDropdown={control.showMonthDropdown}
                                    scrollableYearDropdown={control.scrollableYearDropdown}
                                    yearDropdownItemNumber={control.yearDropdownItemNumber ? control.yearDropdownItemNumber : 15}
                                    placeholderText={control.placeholder}
                                    className={'form-control ' + (shouldMarkError ? "border-danger" : "")}
                                    selected={data[control.key] ? new Date(ControlService().utcToZonedTime(data[control.key], control.dateformat, token)) : null}
                                    onChange={(e) => this.onValueChange(e, control, action)}
                                    onBlur={() => { this.handleBlur(); }}
                                    minDate={this.MinDate(control, data)}
                                    isClearable={true}
                                    popperPlacement="auto"
                                    disabled={this.props.disabled}
                                    portalId="root"
                                // maxDate={addDays(new Date(), 5)}
                                />
                                :
                                <DatePicker
                                    showYearDropdown={!control.hideYearDropdown}
                                    dropdownMode={control.dropdownMode ? "select" : "scroll"}
                                    showMonthDropdown={control.showMonthDropdown}
                                    scrollableYearDropdown={control.scrollableYearDropdown}
                                    yearDropdownItemNumber={control.yearDropdownItemNumber ? control.yearDropdownItemNumber : 15}
                                    placeholderText={control.placeholder}
                                    className={'form-control ' + (shouldMarkError ? "border-danger" : "")}
                                    selected={data[control.key] ? new Date(ControlService().utcToZonedTime(data[control.key], control.dateformat, token)) : null}
                                    onChange={(e) => this.onValueChange(e, control, action)}
                                    onBlur={() => { this.handleBlur(); }}
                                    minDate={this.MinDate(control, data)}
                                    isClearable={true}
                                    popperPlacement={control.popupplacement == 'auto' ? (control.popupplacement + '-left') : (control.popupplacement + '-start')}
                                    disabled={this.props.disabled}
                                // maxDate={addDays(new Date(), 5)}
                                />
                            }
                        </React.Fragment>
                    }
                </div>
                {shouldMarkError &&
                    <small className="form-text text-danger">
                        {control.errormsg ? control.errormsg : 'You must enter a ' + control.label + '.'}
                    </small>
                }
                {control.description ? <div className="form-text">{control.description}</div> : null}
            </div>
        );
    }
}
export default connect(
    mapStateToProps, bindAction
)(DateUI);